import type { TicketStatus } from './ticket-state-machine'

export type DraftUiState = 'hidden' | 'requestable' | 'generating' | 'ready'

const DRAFT_REQUESTABLE_STATUSES: TicketStatus[] = ['EXPERT_REVIEWING', 'RESPONSE_READY']

export function getDraftUiState({
  isExpert,
  status,
  hasDraft,
}: {
  isExpert: boolean
  status: TicketStatus
  hasDraft: boolean
}): DraftUiState {
  if (!isExpert) return 'hidden'
  if (hasDraft) return 'ready'
  if (status === 'RESPONSE_DRAFTING') return 'generating'
  if (DRAFT_REQUESTABLE_STATUSES.includes(status)) return 'requestable'
  return 'hidden'
}
